// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ct2zM","delete":"styles_delete__2emTr","update":"styles_update__PVbby","add":"styles_add__1A4rl"};